import Common from './common.js'

export default {
  Common
}
